import angular from 'angular'

import $$autocomplete from './services/autocomplete.service'
import autocompleteRequest from './services/request.service'
import autocompleteResource from './services/resource.service'

const name = 'autocompleteModule'

angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('$$autocomplete', $$autocomplete)
  .factory('autocompleteRequest', autocompleteRequest)
  .factory('autocompleteResource', autocompleteResource)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/autocomplete/autocomplete.module.js